var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 3.7413,
    viewBox: "0 0 2.6458 .98987",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.005 -125.09)",
    fill: "#dcdcdc"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.22502 0 0 .22502 11.599 207.23)",
    fill: "#dcdcdc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.67,
    y: -365.04,
    width: 11.758,
    height: 4.3991,
    rx: 2.1995,
    ry: 2.1995,
    fillRule: "evenodd",
    stopColor: "#000000",
    style: {
      paintOrder: "markers fill stroke"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m297.53-363.12-0.9843 0.98432-0.98433-0.98431",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.64082
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandBottom);
export default __webpack_public_path__ + "static/media/icon_expand_bottom.f10e466a372c0c5f8d9f1d0e08d30d65.svg";
export { ForwardRef as ReactComponent };